import { DefaultMonthsColumns } from "../../../Utils/DefaultData";

export const DatosEditablesSKIM =
{
    SKIMParaSolidos: { rowName: '(-) SKIM para sólidos', ...DefaultMonthsColumns, isNegative: true },
    GtosFabricacionDelMes: { rowName: '(+) Gtos. Fabricación del mes', ...DefaultMonthsColumns },
    ProdTermMesAnterior: { rowName: '(+) Prod. Term. Mes anterior', ...DefaultMonthsColumns },
    SKIMReclasificadoALatexPorMaquila: { rowName: '(-) Skim reclasificado a latex por maquila', ...DefaultMonthsColumns, isNegative: true },
    CostoVtaDelMes: { rowName: '(-) Costo Vta. Del Mes', ...DefaultMonthsColumns, isNegative: true },
    ProdTerminFinal: { rowName: '(=) Prod. Termin. Final', ...DefaultMonthsColumns },
}

export const SKIMData = {
    ...DatosEditablesSKIM,
}
